import React from 'react'
import {Leaf, Clock, Heart, Users} from 'lucide-react'

function Benefits() {
  const benefits = [
    { icon: Leaf, title: 'Coloque pão quentinho na mesa novamente', text: 'Sem ingredientes difíceis de encontrar. Tudo pode ser comprado em supermercados comuns.' },
    { icon: Clock, title: 'Economize preparando tudo em casa', text: 'Receitas prontas em até 40 minutos, sem gastar fortunas com produtos industrializados' },
    { icon: Heart, title: 'Faça pizzas e croissants que ninguém acredita serem sem glúten', text: 'Textura e sabor de padaria de verdade, sem culpa' },
    { icon: Users, title: 'Alimente sua família sem culpa', text: 'Método testado e aprovado por milhares de famílias' },
  ]

  return (
    <section className="bg-[#FCFAF5] py-24 md:py-36">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16 animate-fade-up max-w-2xl mx-auto">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold mb-4">
            Recupere o prazer de comer o que você ama
          </h2>
          <p className="text-[#49352B]/70 text-lg">
            O Método Massa Perfeita™ traz de volta o prazer da mesa, sem abrir mão da saúde. Tudo isso entregue de forma simples através do aplicativo.
          </p>
        </div>

        <div className="rounded-[20px] overflow-hidden shadow-xl mb-16 animate-fade-up">
          <img
            src="https://static.lumi.new/3c/3c90cb9ec09e359ecd6535870b6ed888.png"
            alt="Cesta de pães artesanais"
            className="w-full h-[320px] md:h-[460px] object-cover"
          />
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8">
          {benefits.map((b, i) => {
            const Icon = b.icon
            return (
              <div key={i} className="bg-white rounded-[20px] p-8 md:p-9 border border-[#EBD9C3] shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-up">
                <div className="w-14 h-14 rounded-full bg-[#EBD9C3] flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-[#D9891B]" />
                </div>
                <h3 className="font-display text-lg font-bold text-[#49352B] mb-3">{b.title}</h3>
                <p className="text-[#49352B]/70 text-sm leading-relaxed">{b.text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Benefits
